import { useState } from 'react';

import cx from 'classnames';

import ActionsDropdown from '~/components/Forms/ActionsDropdown';
import type { PublicationFormQuestion } from '~/interfaces/form';

interface Props {
  question: PublicationFormQuestion;
}

const DropdownInputs = ({ question }: Props) => {
  const [selection, setSelection] = useState('');
  const options = question.form_question_options.map((option) => {
    return {
      name: option.value,
      isCurrent: selection === option.value,
      onClick: () => {
        setSelection(option.value);
      },
      isVisible: () => true,
    };
  });
  const buttonText =
    question.form_question_options.find((option) => option.value === selection)?.value || 'Please select a value';

  return (
    <fieldset className="mt-2 space-y-2">
      <input id={question.id} name={question.id} type="hidden" value={selection} />
      <ActionsDropdown
        buttonText={buttonText}
        size="md"
        actions={[options]}
        node={{}}
        buttonClass={cx(
          selection ? 'text-black' : 'text-gray-400 text-opacity-50',
          'wt-body-font w-full rounded-wt border-2 border-gray-200 text-base font-light shadow-md focus:border-wt-primary focus:outline-none sm:shadow-none',
        )}
        dropdownClass="left-0 wt-body-font text-base rounded-wt font-light text-black shadow-md"
        optionClass="text-left break-words"
      />
    </fieldset>
  );
};

export default DropdownInputs;
